import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchExcludedDishes } from '../actions';
import {
  getDishesByFilter,
  getIsExcludedFetched,
  getIsFetchingExcluded
} from '../selectors';

/**
 * Get data for excluded dishes.
 *
 * Currently fetches all excluded dishes the first time around. Filtering is then
 * done in the selector.
 *
 * @param filter
 * @returns {[boolean, *]}
 */
const useExcludedDishes = filter => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetchingExcluded);
  const isFetched = useSelector(getIsExcludedFetched);
  const filterOnlyExcluded = { ...filter, isExcluded: true };
  const dishes = useSelector(getDishesByFilter(filterOnlyExcluded));

  useEffect(() => {
    if (!isFetched) {
      dispatch(fetchExcludedDishes());
    }
  }, [dispatch, isFetched]);

  return [isFetched ? false : isFetching, dishes];
};

export default useExcludedDishes;
